import Drawer from "@mui/material/Drawer";

import { useAuth } from "../../../../app/providers/AuthProvider";
import {
  SIDEBAR_COLOR_MODE,
  setStoredSidebarDarkMode,
  useSidebarDarkMode,
} from "../../useAppLayoutAppearance";
import MenuContent, { APP_SHELL } from "./MenuContent";

export default function SideMenuMobile({ open, toggleDrawer }) {
  const { isAuthenticated } = useAuth();
  const sidebarDark = useSidebarDarkMode();

  if (!isAuthenticated) return null;

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={toggleDrawer(false)}
      ModalProps={{ keepMounted: true }}
      sx={(theme) => ({
        display: { xs: "block", md: "none" },
        "& .MuiBackdrop-root": {
          backgroundColor: sidebarDark
            ? "rgba(0, 0, 0, 0.42)"
            : "rgba(24, 24, 27, 0.36)",
        },
        "& .MuiDrawer-paper": {
          backgroundImage: "none",
          border: 0,
          boxShadow: "none",
          maxWidth: "calc(100vw - 56px)",
          overflow: "visible",
          width: APP_SHELL.mobileDrawerWidth,
          [theme.breakpoints.down(360)]: {
            maxWidth: "calc(100vw - 48px)",
          },
        },
      })}
    >
      <MenuContent
        mobile
        sidebarDark={sidebarDark}
        onItemClick={toggleDrawer(false)}
        onToggleDarkMode={() => {
          if (!SIDEBAR_COLOR_MODE.toggleEnabled) return;
          setStoredSidebarDarkMode(!sidebarDark);
        }}
      />
    </Drawer>
  );
}
